import React from 'react'

export const WatchIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
      <path d="M11 3.5L6.75 7.75L4.25 5.25L1 8.5" stroke="#1447E6" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M8 3.5H11V6.5" stroke="#1447E6" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  )
}
